/**
 * «API нейросетей с оплатой в рублях» на aisearch.ru (ТЗ Seo-marketing
 * 12.10.2026, владелец одобрил: внешние разработчики подключаются и платят
 * в рублях). Под запросы «api chatgpt в россии», «deepseek api оплата»,
 * «api нейросети python».
 *
 * Адрес /api-neyrosetey: /api на домене занят служебными маршрутами
 * Next.js. Только русская витрина.
 *
 * Сверено 12.10.2026:
 * - примеры кода прогнаны вживую тестовым ключом: библиотека openai для
 *   Python (ai-saga-lite и or/deepseek/deepseek-v3.2), curl
 *   (or/openai/gpt-5-mini), models.list — 261 модель, оба id есть;
 * - 15.10.2026 (решение владельца): id показываются без приставки or/ —
 *   deepseek/deepseek-v3.2, openai/gpt-5-mini. API принимает их с выкатом
 *   AI-Tech-API «модели без or/», старые id остаются синонимами. Таблица
 *   снимает приставку и сама (modeli-ceny.ts), пока на проде старый API,
 *   но примеры кода с новыми id заработают только после выката API:
 *   выпускать страницу после него и прогнать примеры вживую заново;
 * - usage.cost — списанная сумма в валюте кошелька (AI-Tech-API #251, #255),
 *   на aisearch.ru — рубли;
 * - персональные данные маскируются всегда, отключить нельзя
 *   (chat_obezlich.go). Типы — те же, что на странице «Обезличивание»;
 *   имена и места без других данных уходят как есть.
 * Не обещаем: юрлица и акты, СБП, Claude Sonnet и Opus, лимиты частоты.
 */

/** Путь страницы внутри витрины. */
export const PUT_API = '/api-neyrosetey';

/** Адрес API для библиотеки openai. */
export const API_BASE_URL_RU = 'https://api.aisearch.ru/api/v3/llm';

export const TEKST_API = {
  title: 'API ChatGPT, DeepSeek, Gemini в России — оплата в рублях',
  description:
    'Единый API к 250+ моделям: GPT-5 mini, DeepSeek, Gemini, Qwen, Grok. Совместим с библиотекой OpenAI, ключ сразу в кабинете, оплата в рублях с чеком.',
  h1: 'API нейросетей с оплатой в рублях',
  lead: 'Один ключ — доступ к GPT, DeepSeek, Gemini, Qwen, Grok, Llama и ещё двум с лишним сотням моделей. API совместим с библиотекой OpenAI: в своём коде достаточно поменять адрес и ключ. Ключ создаётся в кабинете сразу, без заявки, оплата в рублях, с чеком, VPN не нужен.',
};

export const SHAGI_API = {
  zagolovok: 'Как подключиться',
  shagi: [
    '**Войдите в кабинет** на aisearch.ru.',
    '**Создайте ключ:** «Настройки» → «Ключи для доступа из программ» → «Создать». Ключ показывается один раз — сохраните его.',
    '**Пополните баланс** с любой суммы, если нужны платные модели. Бесплатная модель работает и без пополнения.',
    `**Укажите в коде адрес** ${API_BASE_URL_RU} и свой ключ.`,
  ],
  primerPython: `from openai import OpenAI

client = OpenAI(
    base_url="${API_BASE_URL_RU}",
    api_key="ВАШ_КЛЮЧ",
)

resp = client.chat.completions.create(
    model="deepseek/deepseek-v3.2",
    messages=[{"role": "user", "content": "Объясни, что такое API, в двух предложениях"}],
)
print(resp.choices[0].message.content)`,
  primerCurl: `curl ${API_BASE_URL_RU}/chat/completions \\
  -H "Authorization: Bearer ВАШ_КЛЮЧ" \\
  -H "Content-Type: application/json" \\
  -d '{"model": "openai/gpt-5-mini", "messages": [{"role": "user", "content": "Привет"}]}'`,
  posle:
    'Список моделей с id для поля model — запрос GET /models с тем же ключом, или таблица ниже.',
};

/**
 * Популярные модели — блок над полным каталогом. Только id: цены берутся
 * из /llm/models на сервере, а модель, которой в каталоге нет, просто не
 * показывается — вписанная руками строка устарела бы за неделю.
 */
export const POPULYARNYE_MODELI: { id: string; imya: string }[] = [
  { id: 'deepseek/deepseek-v3.2', imya: 'DeepSeek V3.2' },
  { id: 'deepseek/deepseek-r1-0528', imya: 'DeepSeek R1' },
  { id: 'openai/gpt-5-mini', imya: 'GPT-5 mini' },
  { id: 'openai/gpt-5-nano', imya: 'GPT-5 nano' },
  { id: 'openai/gpt-4.1-mini', imya: 'GPT-4.1 mini' },
  { id: 'google/gemini-2.5-flash', imya: 'Gemini 2.5 Flash' },
  { id: 'google/gemini-3-flash-preview', imya: 'Gemini 3 Flash (preview)' },
  { id: 'anthropic/claude-haiku-4.5:batch', imya: 'Claude Haiku 4.5 (пакетный режим)' },
  { id: 'qwen/qwen3.6-plus', imya: 'Qwen 3.6 Plus' },
  { id: 'x-ai/grok-4.3', imya: 'Grok 4.3' },
  { id: 'meta-llama/llama-4-maverick', imya: 'Llama 4 Maverick' },
];

/**
 * Наши модели — первыми в популярных. ai-saga-lite бесплатна в пределах
 * суточного объёма по ключу; ai-saga-pro стоит за запрос и показывается,
 * только когда API отдаёт её в каталоге (то есть она открыта по ключу).
 */
export const NASHI_MODELI = {
  lite: { id: 'ai-saga-lite', imya: 'AI Saga Lite (наша)' },
  pro: { id: 'ai-saga-pro', imya: 'AI Saga Pro (наша)' },
};

/**
 * Бесплатный объём ai-saga-lite по ключу, если API его не прислал: старый
 * API поля free_tier не знает. Число то же, что в разделе «Бесплатно» и
 * в API (quota.go, уровень Registered).
 */
export const BESPLATNO_LITE_V_SUTKI = 10_000;

/** Строка про бесплатный объём ai-saga-lite. */
export function strokaBesplatno(tokenov: number, estCena: boolean): string {
  const skolko = tokenov.toLocaleString('ru-RU');
  return estCena
    ? `Бесплатно до ${skolko} токенов в сутки по ключу, сверх — по цене за токены`
    : `Бесплатно до ${skolko} токенов в сутки по ключу`;
}

/** Строка цены «Про»: за запрос, длинный — дороже. */
export function strokaZaZapros(zaZapros: number, zaDlinnyj: number | null): string {
  const rub = (v: number) => `${v.toLocaleString('ru-RU')} ₽`;
  return zaDlinnyj === null
    ? `${rub(zaZapros)} за запрос`
    : `${rub(zaZapros)} за запрос, ${rub(zaDlinnyj)} за длинный`;
}

/** Пояснение к «Про» под строкой таблицы. */
export const POYASNENIE_PRO =
  'Длинный — задачи long, rewrite, structure и code или текст длиннее обычного после подтверждения (confirm_price). Задача — поле task в запросе или имя модели вида ai-saga-pro:code.';

export const CENY_API = {
  zagolovok: 'Модели и цены',
  populyarnye: 'Популярные',
  kolonki: ['Модель', 'id', 'Вход, ₽ за 1M токенов', 'Выход, ₽ за 1M токенов'],
  posle:
    'Платите только за использованные токены. Сумма каждого запроса приходит в ответе, в поле usage.cost, в рублях.',
  nedostupno:
    'Каталог сейчас не загрузился. Список моделей с ценами можно получить запросом GET /models.',
};

export const RAZDELY_API: { zagolovok: string; tekst?: string; punkty?: string[] }[] = [
  {
    zagolovok: 'Бесплатно',
    tekst:
      'Без пополнения ключ работает с нашей моделью ai-saga-lite: до 10 000 токенов в сутки, сообщение до 1000 знаков. Этого хватит, чтобы проверить подключение и код. Остальные модели работают после пополнения баланса на любую сумму.',
  },
  {
    zagolovok: 'Оплата в рублях',
    tekst:
      'Баланс общий с кабинетом aisearch.ru и пополняется через ЮKassa, с электронным чеком. Минимальной суммы нет. Подписки нет: деньги списываются только за запросы.',
  },
  {
    zagolovok: 'Чем отличается от прямого API OpenAI',
    tekst:
      'Формат запросов и ответов тот же, поэтому подходят библиотека openai и программы, где можно указать свой адрес API. Отличия:',
    punkty: [
      '**История.** Запросы сохраняются в истории вашего аккаунта.',
      '**Персональные данные.** Телефоны, почта, паспорт, СНИЛС, ИНН, адреса и номера карт заменяются метками перед отправкой модели, имена — вместе с ними. В ответе вы получаете исходный текст. Это работает всегда и не отключается.',
      '**Запрещённые темы.** Такие запросы отклоняются.',
      '**Ошибки.** Коды ошибок свои, формат стандартный — {"error": {"code", "message"}}. Если на балансе нет денег, придёт ошибка 402.',
    ],
  },
];

/** Вопросы: они же уходят в разметку FAQPage. */
export const VOPROSY_API: { vopros: string; otvet: string }[] = [
  {
    vopros: 'Как получить API ChatGPT в России?',
    otvet: `Создайте ключ в кабинете aisearch.ru и укажите в коде адрес ${API_BASE_URL_RU}. Доступны модели OpenAI: GPT-5 mini и nano, GPT-4.1 mini и nano, GPT-4o mini. Зарубежная карта и VPN не нужны.`,
  },
  {
    vopros: 'Как оплатить API DeepSeek из России?',
    otvet:
      'Пополните рублёвый баланс в кабинете: оплата через ЮKassa, с чеком. DeepSeek V3.2, R1 и V4 доступны по тому же ключу, что и остальные модели.',
  },
  {
    vopros: 'Есть ли бесплатный API нейросети?',
    otvet:
      'Да. Наша модель ai-saga-lite бесплатна до 10 000 токенов в сутки, дальше — 31,43 ₽ за 1 млн входящих и 288,12 ₽ за 1 млн исходящих токенов с баланса. Остальные модели платные, оплата по факту, от 1 ₽.',
  },
  {
    vopros: 'Работает ли с библиотекой openai для Python?',
    otvet: `Да. Укажите base_url="${API_BASE_URL_RU}" и свой ключ — остальной код не меняется. Работают обычные ответы, потоковые ответы, вызов инструментов (tools) и ответ в формате JSON.`,
  },
  {
    vopros: 'Есть ли Claude?',
    otvet:
      'Сейчас доступны лёгкие модели Claude — Claude 3 Haiku и Claude Haiku 4.5 в пакетном режиме. Claude Sonnet и Opus в каталоге нет.',
  },
  {
    vopros: 'Сколько стоит API?',
    otvet:
      'Цена зависит от модели и считается за миллион токенов отдельно для запроса и для ответа — таблица выше. Сумма каждого запроса приходит в ответе, в поле usage.cost.',
  },
  {
    vopros: 'Можно ли платить как юрлицо?',
    otvet:
      'Пока нет: оплата только с рублёвого баланса через ЮKassa, без счёта и закрывающих документов.',
  },
];

/** Ссылка на страницу из тарифов и подвала русской витрины. */
export const SSYLKA_NA_API = {
  podval: 'API для разработчиков',
  tarify: 'Нужен доступ к моделям из своего кода? API нейросетей с оплатой в рублях',
};

/** Цена за 1M токенов до рубля; дешевле рубля — с одним знаком. */
export function cenaZaMillion(v: number | null): string {
  if (v === null) return '—';
  if (v === 0) return '0';
  if (v < 1)
    return v.toLocaleString('ru-RU', { maximumFractionDigits: 1, minimumFractionDigits: 1 });
  return Math.round(v).toLocaleString('ru-RU');
}
